import { render, staticRenderFns } from "./attrConfigs.vue?vue&type=template&id=3746a98f&scoped=true&"
import script from "./attrConfigs.vue?vue&type=script&lang=js&"
export * from "./attrConfigs.vue?vue&type=script&lang=js&"
import style0 from "./attrConfigs.vue?vue&type=style&index=0&lang=less&"
import style1 from "./attrConfigs.vue?vue&type=style&index=1&id=3746a98f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3746a98f",
  null
  
)

component.options.__file = "attrConfigs.vue"
export default component.exports